/* ============================================================
   Application routes

   redline.ink is effectively a single-view tool, but `/plan/<slug>`
   must be a first-class deep link: visiting it auto-fetches the
   ciphertext and the reader decrypts using the key in the URL
   fragment (#k=...). Both `/` and `/plan/:slug` render the same
   Reader shell; the slug arrives as a prop. The fragment (the
   decryption key) is intentionally never part of the route — the
   reader reads `location.hash` directly via the crypto module, so
   it never enters router state or any navigation/analytics path.

   ZK note: the key lives only in the fragment, which browsers never
   send to the server. Keep it out of route params and queries.
   ============================================================ */

import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import Reader from './views/Reader.vue'
import AdminView from './views/AdminView.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
  },
  {
    path: '/',
    name: 'home',
    component: Reader,
  },
  {
    path: '/plan/:slug',
    name: 'plan',
    component: Reader,
    // Pass the slug as a prop; the fragment key is read separately.
    props: (route) => ({ slug: String(route.params.slug) }),
  },
  {
    // Hidden dev route: force the first-run welcome experience regardless of
    // local history, so it can be iterated on in isolation. Not linked from the
    // UI; read-only preview — it never touches stored tabs or recents.
    path: '/first-run',
    name: 'first-run',
    component: Reader,
    props: () => ({ firstRunPreview: true }),
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})
